import React, { useRef, useState } from "react";
import { Button } from "reactstrap";
import moment, { invalid } from "moment";
import { useParams } from "react-router-dom";
import { getInvoice, sendEmail } from "../../../../api/invoices"
import { useGetInstence } from "../../../../hooks/useGetInstence";
import InvoiceFooter from "./InvoiceFooter";
import InvoiceHeader from "./InvoiceHeader";
import { useReactToPrint } from "react-to-print";
import "./HoursSheet.css";

export default function HoursSheet({}) {
  const {invoiceId} = useParams()
  const [invoice, setInvoice] = useState(null);
  
  const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
    getInvoice,
    invoiceId,
    (response) => {
      setInvoice({
        ...response.data.data.invoice,
      });
    }
  );

  
  const totalSheetHours = invoice?.invoiceables?.filter(inv => inv.collection).reduce((total, inv) => {
    return total + inv?.collection?.hours.reduce((hourTotal, hour) => hourTotal + hour.hoursLength, 0);
  }, 0);


  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className="page-content hours-sheet" ref={componentRef}>
      <div className="container">
        {!instenceLoading && invoice && (
          <div className="">
            <InvoiceHeader invoice={invoice} type="hours-sheet" total={totalSheetHours}/>

            <div className="separator mb-4 mt-4"></div>

            {invoice.invoiceables.filter((inv) => inv.collection).length > 0 && <>
              {invoice.invoiceables.filter((inv) => inv.collection).map((inv) => {
                  return <>
                    {inv.collection.hours.filter(h => h.hoursLength > 0).map(h => {
                      return <div style={{marginBottom:"30px"}}> 
                          <h4 className="mb-3 fs-15-print">{h.employee.name}</h4>

                          <div className="invoiceable head fs-13-print">
                            <span className="date">Date</span>
                            <span className="date">Start</span>
                            <span className="date">End</span>
                            <span className="hours">Break</span>
                            <span className="hours">Length</span>
                          </div>
                          
                          {h.periods.filter(p => p.length > 0).map(p => <div className="invoiceable fs-13-print">
                              <span className="date">{moment.utc(p.from).format("DD MMM YYYY")}</span>
                              <span className="date">{moment(p.from).format("hh:mm A")}</span>
                              <span className="date">{moment(p.to).format("hh:mm A")}</span>
                              <span className="hours">{p.breakHours}</span>
                              <span className="hours">{p.length}</span>
                          </div>)}
                          
                          <div className="invoiceable mt-2 fs-13-print">
                            <span className="name fw-bold">Total</span>
                            <span className="date"></span>
                            <span className="date"></span>
                            <span className="hours"></span>
                            <span className="hours fw-bold">{h.periods.reduce((total, p) => p.length + total, 0)}</span>
                          </div>

                          <div className="separator mt-4"></div>
                      </div>
                    })}
                  </>
                })
              }
              </>
            }

            <div
              className="mb-4 mt-1 text-end fs-16-print"
              style={{ fontSize: "21px", fontWeight: "bold" }}
            >
              <span>Total: </span>
              <span>{totalSheetHours}</span>
            </div>

            <div className="print text-start">
              <InvoiceFooter invoice={invoice} />
            </div>

            <div className="mb-4 print">
              <Button size="lg" color="primary" onClick={handlePrint}>
                Print
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
